import {
  setMethodology,
  setWordoftheday,
  setCounterMethodology,
  setAcademicProgressEN,
  setAcademicProgressES,
  setAcademicProgressPT,
  setAcademicProgressFR,
  setMethodologyLingoEN,
  setMethodologyLingoES,
  setMethodologyLingoPT,
  setMethodologyLingoFR,
  setMethodologyLingoENInterview,
  setMethodologyLingoESInterview,
  setMethodologyLingoPTInterview,
  setMethodologyLingoFRInterview,
  setWordofthedayByDate,
} from "../slices/content.slice";
import api from "../../services/api";
import { initLoading, endLoading } from "../slices/generics.slice";

const METHODOLOGY_LINGO_LANGUAGES = [
  { languageTranslate: "EN - EN", action: setMethodologyLingoEN },
  { languageTranslate: "EN - ES", action: setMethodologyLingoES },
  { languageTranslate: "EN - PT", action: setMethodologyLingoPT },
  { languageTranslate: "EN - FR", action: setMethodologyLingoFR },
  { languageTranslate: "INTERVIEW - EN", action: setMethodologyLingoENInterview },
  { languageTranslate: "INTERVIEW - ES", action: setMethodologyLingoESInterview },
  { languageTranslate: "INTERVIEW - PT", action: setMethodologyLingoPTInterview },
  { languageTranslate: "INTERVIEW - FR", action: setMethodologyLingoFRInterview },
];

/* Methodology */
export const getMethodology = (lang = "EN", level = "A0", page = 1) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const responseMethodology = await api.get(
        `/contentFiles/get?pageSize=10&pageNumber=${page}&language=${lang}&level=${level}`,
      );
      const responseCounter = await api.get(`/contentFiles/counter?language=${lang}&level=${level}`);

      if (responseMethodology.data?.success) dispatch(setMethodology(responseMethodology.data.result));
      if (responseCounter.data?.success) dispatch(setCounterMethodology(responseCounter.data.result.items[0]));
    } catch (error) {
      console.log("getMethodology", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postMethodology = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const resp = await api.post("contentFiles/add", body);

      if (resp.data?.success) {
        return resp.data.result.items[0];
      }
    } catch (error) {
      console.log("postMethodology", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

export const putMethodology = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const resp = await api.put("/contentFiles/put", body);

      if (resp.data?.success) {
        return resp.data.result.items[0];
      }
    } catch (error) {
      console.log("putMethodology", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

export const searchMethodology = (searchOptions, buttonSelectLanguage, inputSeach, buttonSelectNivel) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const urlBase = `/contentFiles/get?pageSize=20&pageNumber=1&language=${buttonSelectLanguage}&level=${buttonSelectNivel}`;
      const searchParams = {
        cycle: `cycle=${inputSeach}`,
        content: `contentCode=${inputSeach}`,
        classType: `classType=${inputSeach}`,
        cycleName: `cycleName=${inputSeach}`,
        classTitle: `classTitle=${inputSeach}`,
      };

      const queryParam = inputSeach !== "" ? searchParams[searchOptions] : "";
      const response = await api.get(`${urlBase}&${queryParam}`);

      if (response.data?.success) {
        dispatch(setMethodology(response.data.result));
      }
    } catch (error) {
      console.log("searchMethodology", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

/* Wordoftheday */
export const getWordoftheday = (lang = "EN", page = 1, date = "") => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      let url = "";

      if (date) {
        url = `/customTexts/get-texts-by-date?language=${lang}&date=${date}&textType=WORDOFTHEDAY&pageSize=21&pageNumber=${page}`;
      } else {
        url = `/customTexts/get-texts-by-date?language=${lang}&textType=WORDOFTHEDAY&pageSize=21&pageNumber=${page}`;
      }
      const response = await api.get(url);

      if (response.data?.success) dispatch(setWordoftheday(response.data.result));
    } catch (error) {
      console.log("getWordoftheday", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postWordoftheday = (body) => {
  return async (dispatch) => {
    try {
      dispatch(initLoading());

      const response = await api.post("/customTexts/add", body);

      if (!response.data?.success) return;
      return response.data.result.items[0];
    } catch (error) {
      console.log("postWordoftheday", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

export const putWordoftheday = (body) => {
  return async (dispatch) => {
    try {
      dispatch(initLoading());

      const response = await api.put("/customTexts/put", body);

      if (!response.data?.success) return;
      return response.data.result.items[0];
    } catch (error) {
      console.log("putWordoftheday", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

/* AcademicProgress */
export const getAcademicProgress = (lang = "EN", level) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      api
        .get(`/customTexts/get?pageSize=20&pageNumber=1&language=${lang}&textType=ACADEMICPROGRESS&level=${level}`)
        .then((resp) => {
          const items = resp?.data?.result?.items;

          if (resp?.data?.success && items.length > 0) {
            dispatch(
              setAcademicProgressEN({
                id: items?.find((item) => item?.languageTranslate === `${lang} - EN`)?.id ?? "",
                content: items?.find((item) => item?.languageTranslate === `${lang} - EN`)?.content ?? "",
              }),
            );
            dispatch(
              setAcademicProgressES({
                id: items?.find((item) => item?.languageTranslate === `${lang} - ES`)?.id ?? "",
                content: items?.find((item) => item?.languageTranslate === `${lang} - ES`)?.content ?? "",
              }),
            );
            dispatch(
              setAcademicProgressPT({
                id: items?.find((item) => item?.languageTranslate === `${lang} - PT`)?.id ?? "",
                content: items?.find((item) => item?.languageTranslate === `${lang} - PT`)?.content ?? "",
              }),
            );
            dispatch(
              setAcademicProgressFR({
                id: items?.find((item) => item?.languageTranslate === `${lang} - FR`)?.id ?? "",
                content: items?.find((item) => item?.languageTranslate === `${lang} - FR`)?.content ?? "",
              }),
            );
            dispatch(
              setAcademicProgressFR({
                id: resp.data.result.items?.find((item) => item?.languageTranslate === `${lang} - FR`).id,
                content: resp.data.result.items?.find((item) => item?.languageTranslate === `${lang} - FR`).content,
              }),
            );
          } else {
            dispatch(setAcademicProgressEN({ id: "", content: "" }));
            dispatch(setAcademicProgressES({ id: "", content: "" }));
            dispatch(setAcademicProgressPT({ id: "", content: "" }));
            dispatch(setAcademicProgressFR({ id: "", content: "" }));
          }
        })
        .catch((e) => console.log("customTexts: ", e));
    } catch (error) {
      console.log("getAcademicProgress", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postAcademicProgress = (body) => {
  return async (dispatch) => {
    try {
      dispatch(initLoading());

      const response = await api.post("/customTexts/add", body);

      if (!response.data?.success) return;
      return response.data.result.items[0];
    } catch (error) {
      console.log("postAcademicProgress", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

export const putAcademicProgress = (body) => {
  return async (dispatch) => {
    try {
      dispatch(initLoading());

      const response = await api.put("/customTexts/put", body);

      if (!response.data?.success) return;
      return response.data.result.items[0];
    } catch (error) {
      console.log("putAcademicProgress", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

const buildMethodologyLingoPayload = (items, languageTranslate) => {
  const item = items?.find((current) => current?.languageTranslate === languageTranslate);

  if (!item) return { id: "", content: "" };
  return { id: item.id ?? "", content: item.content ?? "" };
};

export const getMethodologyLingo = () => {
  return async (dispatch) => {
    try {
      dispatch(initLoading());

      const { data } = await api.get("/customTexts/get?pageSize=20&pageNumber=1&textType=METHODOLOGYLINGOFORME");

      const items = data?.success ? data?.result?.items ?? [] : [];

      METHODOLOGY_LINGO_LANGUAGES.forEach(({ languageTranslate, action }) => {
        dispatch(action(buildMethodologyLingoPayload(items, languageTranslate)));
      });
    } catch (error) {
      console.log("getMethodologyLingo", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postMethodologyLingo = (body) => {
  return async (dispatch) => {
    try {
      dispatch(initLoading());

      const response = await api.post("customTexts/add", body);

      if (!response.data?.success) return;
      return response.data.result.items[0];
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(endLoading());
    }
  };
};

export const putMethodologyLingo = (body) => {
  return async (dispatch) => {
    try {
      dispatch(initLoading());

      const response = await api.put("/customTexts/put", body);

      if (!response.data?.success) return [];
      return response.data.result.items[0];
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getWordofthedayByDate = (lang = "EN", date = "") => {
  return async (dispatch) => {
    try {
      const response = await api.get(
        `/customTexts/get-texts-by-date?language=${lang}&date=${date}&textType=WORDOFTHEDAY&pageSize=3&pageNumber=1`,
      );

      if (response.data?.success) dispatch(setWordofthedayByDate(response.data.result.items[0]));
    } catch (error) {
      console.log("getWordofthedayByDate", error);
    }
  };
};
